import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getCourses } from "@/services/apiCourses";

export function useCourses({ filter, include, includeFields, sortBy, page = 1, perPage = 3 } = {}) {
  const queryClient = useQueryClient();

  const {
    isPending,
    data: courses,
    isSuccess,
  } = useQuery({
    queryKey: ["courses", page, perPage, filter, include, includeFields, sortBy],
    queryFn: () => getCourses({ filter, include, includeFields, sortBy, page, perPage }),
  });

  const totalPages = Math.ceil(courses?.meta?.total / courses?.meta?.per_page);

  // PRE-FETCHING
  if (isSuccess && page < totalPages) {
    queryClient.prefetchQuery({
      queryKey: ["courses", page, perPage, filter, include, includeFields, sortBy],
      queryFn: () =>
        getCourses({
          filter,
          include,
          includeFields,
          sortBy,
          page: page++,
          perPage,
        }),
    });
  }

  if (isSuccess && page > 1) {
    queryClient.prefetchQuery({
      queryKey: ["courses", page, perPage, filter, include, includeFields, sortBy],
      queryFn: () =>
        getCourses({
          filter,
          include,
          includeFields,
          sortBy,
          page: page--,
          perPage,
        }),
    });
  }

  return { isPending, courses };
}
